/// <reference path="../List/FormatLookupEditor.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerEditor()
    export class FormatViewLookupEditor extends FormatLookupEditorBase<ViewLookupEditorOptions, any> {

        constructor(input: JQuery, opt: ViewLookupEditorOptions) {
            super(input, opt);
        }

        protected getLookupKey() {
            return "ViewLookup." + this.options.viewName;
        }
    }

    export interface FormatViewLookupEditorOptions extends FormatLookupEditorOptions {
        viewName: string;
    }
}